import ModalDeleteFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { useFetchText } from '../../../../../../../utils/hooks/useFetchText'
import { useCallback } from 'react'
import { useNavigate, useLocation } from 'react-router'
import { OnSubmit } from '../../../../../../../forms/TwinForm/types'
import { getBasePath } from '../../../../../../../utils/globals/link'

interface ModalDeleteFeatureProps extends ModalEditComponentProps { }

const ModalDeleteFeature: React.FC<ModalDeleteFeatureProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleOnSubmit } = useModalDeleteFeatureLogic({ onSubmit })
    const { handleFetchText } = useFetchText({
        onSubmit: handleOnSubmit,
        url: '/api/app/product/feature/deleteFeature',
        data: {
            id: allRowData?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteFeature', '¿Seguro quieres eliminar esta característica?'),
            subtitle: t('onceDeletedNotRecover', 'Una vez eliminada no podrás recuperarla')
        }} />
    )
}

interface ModalDeleteFeatureLogicProps {
    onSubmit: OnSubmit
}

const useModalDeleteFeatureLogic = ({onSubmit}: ModalDeleteFeatureLogicProps) => {
    const navigate = useNavigate();
    const location = useLocation().pathname
    
    const handleOnSubmit: OnSubmit = useCallback((res, value) => {
        onSubmit(res, value)
        navigate(getBasePath(location, 'features') + '/main')
    }, [onSubmit, navigate, location])

    return { handleOnSubmit }
}



export default ModalDeleteFeature